import { useMutation } from '@apollo/client';
import { DELETE_STUDIO_CREATIVE } from '../../graphql/mutations/creativeMutations';

/**
 * Hook to delete a link between a Studio and a Creative
 * @returns {object} - { handleDeleteStudioCreative, loading, error }
 */
export const useDeleteStudioCreative = () => {
  const [deleteStudioCreativeMutation, { loading, error }] = useMutation(DELETE_STUDIO_CREATIVE, {
    refetchQueries: [
      'StudioCreativesByStudioID', 
      'StudioCreativesByCreativeID',
      'GetStudio',
      'GetCreative'
    ],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleDeleteStudioCreative = async (linkData) => {
    try {
      if (!linkData?.id) {
        throw new Error('Die Verknüpfung zwischen Studio und Creative-Profil konnte nicht zugeordnet werden. Bitte lade die Seite neu und versuche es erneut.');
      }

      const input = sanitizeInput({
        id: linkData.id
      });

      const variables = sanitizeInput({
        input,
        condition: linkData?.condition
      });

      const { data: linkResponse } = await deleteStudioCreativeMutation({
        variables
      });

      return linkResponse?.deleteStudioCreative;
    } catch (error) {
      console.error('Error deleting studio-creative link:', error);
      throw error;
    }
  };

  /**
   * Helper to delete link by studio and creative IDs
   * Note: This requires finding the link ID first, or you can pass the link ID directly
   */
  const deleteStudioCreativeByIds = async (studioId, creativeId, condition) => {
    // This would require a query first to find the link ID
    // For now, we'll just throw an error suggesting to use handleDeleteStudioCreative with the link ID
    throw new Error('Bitte lösche die Studio-Creative-Verknüpfung über die Verknüpfungs-ID.');
  };

  return {
    handleDeleteStudioCreative,
    deleteStudioCreativeByIds,
    loading,
    error
  };
};
